const LOGIN_STAGES = [
  'app_load',
  'auth_restore_started',
  'auth_restore_complete',
  'credentials_submitted',
  'auth_request_dispatched',
  'auth_response_received',
  'session_established',
  'account_bootstrap_complete',
  'route_transition_started',
  'route_transition_complete',
  'preferences_load_started',
  'preferences_load_complete',
  'conversation_history_load_started',
  'conversation_list_complete',
  'active_thread_messages_complete',
  'conversation_history_load_complete',
  'conversation_ready_render',
  'composer_usable',
  'chat_first_meaningful_render',
];

let activeTrace = { marks: new Map([['app_load', clockNow()]]), reported: false, kind: 'restore' };

function clockNow() {
  return typeof performance !== 'undefined' && typeof performance.now === 'function'
    ? performance.now()
    : Date.now();
}

export function startLoginLatencyTrace() {
  activeTrace = { marks: new Map([['app_load', clockNow()]]), reported: false, kind: 'login' };
  markLoginLatency('credentials_submitted');
}

export function markLoginLatency(stage) {
  if (!activeTrace || !LOGIN_STAGES.includes(stage) || activeTrace.marks.has(stage)) return;
  activeTrace.marks.set(stage, clockNow());
}

export function readLoginLatencyTrace() {
  if (!activeTrace) return null;
  const marks = Object.fromEntries(activeTrace.marks);
  const duration = (from, to) => (
    Number.isFinite(marks[from]) && Number.isFinite(marks[to])
      ? Math.max(0, marks[to] - marks[from])
      : null
  );
  return {
    marks,
    spans: {
      submit_to_dispatch: duration('credentials_submitted', 'auth_request_dispatched'),
      authentication: duration('auth_request_dispatched', 'auth_response_received'),
      response_to_session: duration('auth_response_received', 'session_established'),
      account_bootstrap: duration('session_established', 'account_bootstrap_complete'),
      route_transition: duration('route_transition_started', 'route_transition_complete'),
      preferences_load: duration('preferences_load_started', 'preferences_load_complete'),
      conversation_history_load: duration('conversation_history_load_started', 'conversation_history_load_complete'),
      conversation_list: duration('conversation_history_load_started', 'conversation_list_complete'),
      active_thread_messages: duration('conversation_list_complete', 'active_thread_messages_complete'),
      conversation_ready: duration('route_transition_started', 'conversation_ready_render'),
      composer_ready: duration('route_transition_started', 'composer_usable'),
      auth_restore: duration('auth_restore_started', 'auth_restore_complete'),
      submit_to_chat_render: duration('credentials_submitted', 'chat_first_meaningful_render'),
    },
  };
}

export function reportLoginLatencyTrace() {
  if (!activeTrace || activeTrace.reported) return readLoginLatencyTrace();
  const trace = readLoginLatencyTrace();
  const complete = trace?.marks?.chat_first_meaningful_render
    && trace.marks.preferences_load_complete
    && trace.marks.conversation_history_load_complete;
  if (!complete) return trace;
  activeTrace.reported = true;
  // Content-free timing only: no username, account ID, session ID, or history.
  console.info('[LOGIN_LATENCY]', trace.spans);
  return trace;
}
